define('views/modules/calendar/animated-session/exercise/edit/exercise-edit-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/base-panel',
    //services
    'services/events/animated-session-events',
    // views content
    'views/modules/calendar/animated-session/exercise/edit/exercise-edit-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    //services
    AnimationEvents,
    // views content
    VExerciseEditContent
) {

    var VExerciseEditPanel = VBasePanel.extend({
        header: {
            title: "calendar:Edit my sets",
            subtitle: "calendar:Edit your reps and load",
        },
        tabs: [{ id: 'edit', title: 'Edit', active: true }],
        content: {
            edit: VExerciseEditContent,
        },

        defaultView: 'edit',

        initialize: function(opt) {
            opt = opt || {};
            var edit = this.getView('edit', {
                model: this.model,
                item: opt.item,
                profile: opt.profile,
                session: opt.session
            });
            this.listenTo(edit, { 'form:success': this.onSuccess })
                .listenTo(edit, { 'exercise:done': this.onExerciseDone })
                .listenTo(Backbone.history, "route", this.close);

            this.listenTo(AnimationEvents, {
                'exercise:editFinish': this.close,
            });
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            this.view.edit.model = this.model;
            return this;
        },

        close: function() {
            var modelCopy = this.view.edit.getModelCopy();
            this.model.reset(modelCopy.attributes, { silent: true });
            VExerciseEditPanel.__super__.close.apply(this, arguments);
        },

        onSuccess: function(model, shouldClose) {
            this.trigger('form:success', model);
            if (shouldClose) return;
            this.trigger('back');
        },

        onExerciseDone: function(model) {
            this.trigger('exercise:done', model);
        },

    });

    return VExerciseEditPanel;
});

